import { 
    FETCH_WITHDRAWSREFER,
    FETCH_WITHDRAWSREFER_SUCCESS,
    FETCH_WITHDRAWSREFER_FAILED,
    EDIT_WITHDRAWSREFER
    } from "../store/types";
    
    export const INITIAL_STATE = {
      withdraws:null,
      loading: false,
      error:{
        flag:false,
        msg: null
      }
    }
    
    export const withdrawreferreducer = (state = INITIAL_STATE, action) => {
      switch (action.type) {
        case FETCH_WITHDRAWSREFER:
          return {
            ...state,
            loading:true
          };
        case FETCH_WITHDRAWSREFER_SUCCESS:
          return {
            ...state,
            withdraws:action.payload,
            loading:false
          };
        case FETCH_WITHDRAWSREFER_FAILED:
          return {
            ...state,
            withdraws:null,
            loading:false,
            error:{
              flag:true,
              msg:action.payload
            }
          };
        case EDIT_WITHDRAWSREFER:
          return state;
        default:
          return state;
      }
    };